// base styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";
import boxShadows from "assets/mavric-theme/base/boxShadows";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { primary, secondary, transparent } = colors;
const { borderRadius } = borders;
const { tabsBoxShadow } = boxShadows;

const tabs = {
  styleOverrides: {
    root: {
      position: "relative",
      backgroundColor: primary.main,
      //borderRadius: borderRadius.xl,
      minHeight: "unset",
      //padding: pxToRem(2),
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
      display: `-webkit-box !important`,
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "20%",
      },
    },

    indicator: {
      height: "8%",
      //borderRadius: borderRadius.lg,
      backgroundColor: transparent,
      //boxShadow: tabsBoxShadow.indicator,
      transition: "all 500ms ease",
    },
  },
};

export default tabs;
